<!--  -->
<template>
  <div class="city-popver-checkbox">
    <div class="dialog-header">
      <span class="headler-label">选择所在地区：</span>
      <el-radio-group v-model="provinceRadio" @change="handleRadioChange">
        <el-radio label="1">全选</el-radio>
        <el-radio label="2">全不选</el-radio>
        <el-radio label="3">排除偏远地区</el-radio>
        <el-radio label="4">自定义</el-radio>
      </el-radio-group>
    </div>
    <div
      v-for="(list, indexA) in areaData.children"
      :key="'area' + indexA"
      style="margin-bottom: 10px"
    >
      <el-checkbox-group v-model="areaData.arr" @change="provinceRadio = '4'">
        <div style="float: left; width: 100px">
          <el-checkbox
            :indeterminate="list.indeterminate"
            v-model="list.checked"
            :label="list.name"
            @change="(val) => handleCheckChange(list, val)"
            style="margin-bottom: 5px; line-height: 19px"
            >{{ list.name }}</el-checkbox
          >
        </div>
        <el-checkbox-group v-model="list.arr" @change="provinceRadio = '4'">
          <span
            v-for="(province, index) in list.children"
            :key="'province' + index"
            style="
              display: inline-block;
              margin-right: 30px;
              width: 130px;
              margin-bottom: 10px;
              line-height: 19px;
            "
          >
            <el-popover placement="bottom-start" width="450" trigger="hover">
              <!-- 省 -->

              <el-checkbox
                slot="reference"
                :indeterminate="province.indeterminate"
                v-model="province.checked"
                :label="province.model"
                @change="(val) => handleCheckChange(province, val)"
                >{{ province.name }} ({{ province.checkTotal }})</el-checkbox
              >
              <!-- {{( province.checkTotal )}} -->
              <!-- 市 -->
              <el-checkbox-group
                v-model="province.arr"
                @change="provinceRadio = '4'"
              >
                <div style="display: inline-block; margin-top: 10px">
                  <el-checkbox
                    style="
                      display: inline-block;
                      margin-top: 10px;
                      width: 110px;
                    "
                    v-for="city in province.children"
                    v-model="city.checked"
                    :label="city.title"
                    :key="'city' + city.name"
                    @change="
                      (val) => handleCityChange(city, val, indexA, index)
                    "
                  >
                    <el-tooltip
                      v-if="city.name.length > 4"
                      class="item"
                      effect="light"
                      :content="city.name"
                      placement="top-start"
                    >
                      <span>{{ city.name | cityLength }}</span>
                    </el-tooltip>
                    <span v-else>{{ city.name | cityLength }}</span>
                  </el-checkbox>
                </div>
              </el-checkbox-group>
            </el-popover>
          </span>
        </el-checkbox-group>
      </el-checkbox-group>
    </div>
    <div class="btn" style="width: 100%; text-align: right; margin-top: 50px">
      <el-button
        @click="closeDialog(1)"
        style="width: 98px; height: 32px"
        type="primary"
        >确认</el-button
      >
      <el-button @click="closeDialog(2)" style="width: 98px; height: 32px"
        >关闭</el-button
      >
    </div>
  </div>
</template>

<script>
import { getArea } from "@/api/memberLabel";
import { mapState, mapMutations } from "vuex";
let that;
const RESET_AREA = [];
export default {
  props: {
    checkedList: {
      type: Array,
      default: () => [],
    },
    isProvince: {
      // 是否带省的数据传出
      type: Boolean,
      default: false,
    },
  },
  watch: {
    checkedList(newVal) {
      // console.log('checkedList', newVal);
      this.handleControl();
    },
  },
  filters: {
    cityLength(v) {
      return v.length <= 4 ? v : v.substr(0, 4) + "...";
    },
  },
  data() {
    return {
      provinceRadio: "4",
      copyCheckList: [],
      areaData: {
        children: [],
        arr: [],
      },
      areaLastList: [],
    };
  },

  created() {
    // console.log('checkedList', this.checkedList);
    this.init();
  },
  beforeCreate: function () {
    that = this;
  },
  computed: {
    ...mapState({
      cityProvinceData: "cityProvinceData",
    }),
  },
  methods: {
    ...mapMutations({
      saveProvinceData: "CITYPROVINCEDATA",
    }),
    closeDialog(v) {
      // console.log('this.areaData:', this.areaData)
      this.$emit("closeFn", v);
    },

    init() {
      console.log('this.cityProvinceData:', this.cityProvinceData)
      if (this.cityProvinceData && this.cityProvinceData.length > 0) {
        this.renderData(JSON.parse(JSON.stringify(this.cityProvinceData)))
      } else {
        getArea().then((res) => {
          if (res.code === 1) {
            this.saveProvinceData(JSON.parse(JSON.stringify(res.data)));
            this.renderData(JSON.parse(JSON.stringify(res.data)))
          }
        });
      }
     
    },
    // 格式化数据
    renderData(list) {
      let cityArr = [];
      // return
      // 格式化数据
      list.forEach((item) => {
        item.checked = false;
        item.indeterminate = false;
        item.model = item.name;
        item.arr = [];
        item.parent = this.areaData;
        // 省份
        item.children.forEach((province) => {
          province.checked = false;
          province.indeterminate = false;
          province.arr = [];
          province.checkTotal = 0;
          province.model = province.name;
          province.parent = item;

          // 城市
          province.children.forEach((city) => {
            cityArr.push(city);
            city.model = city.title;
            city.checked = false;
            city.parent = province;

            // 偏远地区保存
            if (
              province.name == "新疆维吾尔自治区" ||
              province.name == "青海省" ||
              province.name == "西藏自治区" ||
              province.name == "云南省"
            ) {
              RESET_AREA.push(city.title);
            }
          });
          province.children = province.children;
        });
        item.children = item.children;
      });
      // console.log(cityArr);

      this.areaData.children = list;
      // console.log(this.areaData);
      this.areaLastList = this.getLast(this.areaData);
      // console.log(this.areaData.children);
      this.handleControl();
    },
    handleRadioChange(val) {
      switch (val) {
        case "1":
          this.handleCheckChange(this.areaData, true);
          break;
        case "2":
          this.areaLastList.forEach((item) => {
            this.handleCityChange(item, false);
          });
          break;
        case "3":
          this.handleCheckChange(this.areaData, true);
          RESET_AREA.forEach((item) => {
            const res = this.areaLastList.find((city) => city.model === item);
            this.handleCityChange(res, false);
          });
          break;
        case "4":
          break;
      }
      this.checkTotle();
    },

    handleCheckChange(list, val) {
      const arr = this.getLast(list); //获取城市
      // console.log(arr);
      arr.forEach((item) => {
        this.handleCityChange(item, val);
      });
      this.checkTotle();
    },

    handleCountChange(list) {
      // console.log(list);
      if (!list.children) return false;
      const count = list.children.reduce((prev, item) => {
        return (prev += item.checked ? 1 : 0);
      }, 0);
      const arrLen = list.children.length;
      list.checked = count > 0;
      list.indeterminate = count > 0 && list.arr.length < arrLen;
      if (list.parent) {
        const arr = list.parent.arr;
        const index = arr.findIndex((item) => item === list.model);
        if (count === list.children.length) {
          if (index === -1) arr.push(list.model);
        } else {
          if (index !== -1) arr.splice(index, 1);
        }
        this.handleCountChange(list.parent);
      }
    },
    // 城市勾选
    handleCityChange(city, checked, i, k) {
      // console.log(city);
      city.checked = checked;
      const arr = [];
      city.parent.children.forEach((item) => {
        item.checked && arr.push(item.model);
      });
      city.parent.arr = arr;
      // console.log(city.parent);
      this.handleCountChange(city.parent);

      // 省级选框后的已选数
      if (i || k || i == 0 || k == 0) {
        this.areaData.children[i].children.forEach((item, index) => {
          // console.log(item);
          item.checkTotal = 0;
          item.children.forEach((itemA, indexA) => {
            if (itemA.checked) {
              item.checkTotal = item.checkTotal + 1;
            }
          });
        });
      }
    },

    // 城市选择totle
    checkTotle() {
      this.areaData.children.forEach((item, index) => {
        item.children.forEach((itemA, indexA) => {
          itemA.checkTotal = 0;
          itemA.children.forEach((itemB, indexB) => {
            if (itemB.checked) {
              itemA.checkTotal = itemA.checkTotal + 1;
            }
          });
        });
      });
    },
    // 回现
    handleControl() {
      let copyCheckList = [];
      try {
        if (!this.isProvince) {
          copyCheckList = this.checkedList;
        } else {
          this.checkedList.forEach((item) => {
            var city = item.city;
            if (city) {
              copyCheckList.push(...city.split(","));
            }
          });
        }

        //copyCheckList = [];
        copyCheckList.forEach((item) => {
          // const city = this.areaLastList.find(city => city.title === item);
          const city = this.areaLastList.find((city) => city.name === item);
          if (!city) return false;
          // console.log(city);
          this.handleCityChange(city, true);
        });
        this.checkTotle();
        //    this.areaData.children[i].children.forEach((item, index) => {
        //   item.checkTotal=0
        //   item.children.forEach((itemA, indexA) => {
        //     if (itemA.checked) {
        //       item.checkTotal = item.checkTotal + 1;
        //     }
        //   });
        // });
      } catch (e) {}
    },
    // 获取最子集合
    getLast(obj) {
      const res = [];
      obj.children.forEach((item) => {
        if (item.children) {
          res.push(...this.getLast(item));
        } else {
          res.push(item);
        }
      });
      return res;
    },
    getResult() {
      const arr = [];

      // console.log('this.this.areaData:', this.areaData)
      if (!this.isProvince) {
        this.areaLastList.forEach((item) => {
          item.checked && arr.push(item.name);
        });
      } else {
        var areaData = this.areaData.children;
        areaData.forEach((areaItem) => {
          // 区域，东南西北
          if (areaItem) {
            if (areaItem.checked) {
              areaItem.children.forEach((provinceItem) => {
                // 省份
                if (provinceItem.checked) {
                  var city = [];
                  provinceItem.children.forEach((cityItem) => {
                    // 市
                    if (cityItem.checked) {
                      city.push(cityItem.name);
                    }
                  });
                  var obj = {
                    code: this.provinceToCode(provinceItem.name),
                    city: city.join(","),
                  };
                  arr.push(obj);
                }
              });
            }
          }
        });
      }

      // console.log(arr);
      return arr;
    },
  },
};
</script>
<style lang='scss' scoped>
.dialog-header {
  margin-bottom: 20px;
}
.headler-label {
  font-size: 16px;
  margin-right: 30px;
}
</style>
